import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ViewFormContext } from '../store/store.ViewForm'
import LoadingPage from '../../../../components/Loading/LoadingPage'
import { toJS } from 'mobx'
import { useLocation } from 'react-router-dom'

const AuthorizationGuardViewForm = observer(({ children }) => {
  const navigate = useNavigate()
  const viewFormContext = useContext(ViewFormContext)
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const flag = useRef(false)

  useEffect(() => {
    if (flag.current === false) {
      const checkPermission = async () => {
        await viewFormContext.initialisationGET()
        if (!viewFormContext.hasPermission) {
          if (viewFormContext.errorCode === 'NEEDS_AUTH') {
            localStorage.setItem(
              'redirectPath',
              location.pathname + location.search
            )
            navigate('/login')
          } else {
            navigate('/forbidden') // Autres cas d'accès interdit
          }
        }
        setLoading(false)
      }
      checkPermission()
    }

    return () => (flag.current = true)
  }, [navigate])

  useEffect(() => {
    if (viewFormContext.hasPermission === false) {
      //   navigate('/forbidden')
      console.log('je redirige')
    }
  }, [viewFormContext.hasPermission, navigate])

  if (loading) {
    return <LoadingPage />
  }

  return children
})

export default AuthorizationGuardViewForm
